import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "modalForm", "submitButton", "clearInactivity",
    "inactiveUntilModalFrame", "currentInactiveUntilDisplay", "setInactiveUntilButton", "setInactiveInFutureButton",
    "inactiveUntilDateInput", "inactiveMinutesInput" ];

  static values = {
    initialInactiveUntil: String
  };

  declare modalFormTargets: HTMLFormElement[];
  declare submitButtonTarget: HTMLButtonElement;
  declare inactiveUntilModalFrameTarget: HTMLElement;

  declare clearInactivityTarget: HTMLInputElement;

  declare hasInactiveMinutesInputTarget: boolean;
  declare inactiveMinutesInputTarget?: HTMLSelectElement

  declare hasInactiveInFutureInputTarget: boolean;
  declare inactiveInFutureInputTarget?: HTMLInputElement;

  declare hasInactiveUntilDateInputTarget: boolean;
  declare inactiveUntilDateInputTarget?: HTMLInputElement;

  declare hasCurrentInactiveUntilDisplayTarget: boolean;
  declare currentInactiveUntilDisplayTarget?: HTMLElement;

  resetStoreStatusDropdown() {
    this.clearInactivityTarget.value = "";
    if (this.hasCurrentInactiveUntilDisplayTarget) {
      this.currentInactiveUntilDisplayTarget!.classList.remove("is-hidden");
    }
  }

  handleClearInactiveUntil(): void {
    this.clearInactivityTarget.value = "true";

    if (this.hasCurrentInactiveUntilDisplayTarget) {
      this.currentInactiveUntilDisplayTarget!.classList.add("is-hidden");
    }
  }

  resetFormFields() {
    this.resetStoreStatusDropdown();
    if (this.hasInactiveMinutesInputTarget) {
      this.inactiveMinutesInputTarget!.value = "30"
    }
    if (this.hasInactiveUntilDateInputTarget) {
      this.inactiveUntilDateInputTarget!.value = this.inactiveUntilDateInputTarget!.defaultValue;
    }
    if (this.hasInactiveInFutureInputTarget) {
      this.inactiveInFutureInputTarget!.value = this.inactiveInFutureInputTarget!.defaultValue;
    }
  }

  toggleInactiveUntilModal(): void {
    this.resetStoreStatusDropdown();
    this.resetFormFields();
    this.inactiveUntilModalFrameTarget.classList.toggle("is-active");
  }

  alignFormTarget(): void {
    const correspondingForm = this.modalFormTargets.find((form) => form.parentElement && !(form.parentElement.classList.contains("is-hidden")));

    if (correspondingForm?.id) {
      this.submitButtonTarget.setAttribute("form", correspondingForm.id);
      this.submitButtonTarget.disabled = false;
    } else {
      this.submitButtonTarget.removeAttribute("form");
      this.submitButtonTarget.disabled = true;
    }
  }
}
